import { useSelection } from 'craft/hooks';
import { useFlowAncestor } from 'craft/state';

import { checkConditions } from './checkConditions';
import { useShortcutQueries } from './useShortcutQueries';

export const useFlowsShortcuts = () => {
  const { selection } = useSelection();
  const { isInSelectionMode } = useShortcutQueries();

  const { isInFlow, onNextStep, onPreviousStep } = useFlowAncestor(selection.first);
  return {
    keyMap: {
      nextFlowStep: {
        hotkeys: ['f'],
        enabled: checkConditions(isInSelectionMode, () => isInFlow),
      },
      previousFlowStep: {
        hotkeys: ['shift+f'],
        enabled: checkConditions(isInSelectionMode, () => isInFlow),
      },
    },
    handlers: {
      nextFlowStep: () => {
        onNextStep();
      },
      previousFlowStep: () => {
        onPreviousStep();
      },
    },
  };
};
